











































































import Vue from "vue";
import { FilterConfig, FilterResult } from "./types";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => FilterResult[],
      required: true,
    },
    filters: {
      type: Array as () => FilterConfig[],
      required: true,
    },
  },
  watch: {
    filterDatas: {
      deep: true,
      handler(newValue) {
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.refresh(newValue);
        }, 500);
      },
    },
    filters: {
      immediate: true,
      handler() {
        this.initFilters();
      },
    },
  },
  data(): any {
    return {
      initialQuery: [] as FilterResult[],
      filterDatas: {} as { [key: string]: { operator: string; value: any } },
      valid: false,
      delay: undefined,
    };
  },
  mounted() {
    this.initFilters();
  },
  methods: {
    initFilters() {
      for (const filter of this.filters) {
        this.resetFilter(filter);
      }

      this.initialQuery = (this.value as FilterResult[]).filter(
        filterResult => !(this.filters as FilterConfig[]).find(filterConfig => filterConfig.key === filterResult.key)
      );
    },
    resetFilter(filter: FilterConfig) {
      const existingFilterResult = this.value
        ? (this.value as FilterResult[]).find(filterResult => filterResult.key === filter.key)
        : undefined;
      if (filter.operator == "BETWEEN") {
        this.$set(this.filterDatas, filter.key, {
          value: existingFilterResult ? existingFilterResult.value : { from: undefined, to: undefined },
          operator: filter.operator,
        });
      } else if (filter.operator == "IN") {
        this.$set(this.filterDatas, filter.key, {
          value: existingFilterResult ? existingFilterResult.value : [],
          operator: filter.operator,
        });
      } else {
        this.$set(this.filterDatas, filter.key, {
          value: existingFilterResult ? existingFilterResult.value : undefined,
          operator: filter.operator,
        });
      }
    },
    isFilterActive(filter: any) {
      if (filter.operator == "BETWEEN") {
        if (filter.value.to || filter.value.from) {
          return true;
        }
      } else if (filter.operator == "IN") {
        if (filter.value.length > 0) {
          return true;
        }
      } else {
        if (filter.value != undefined && filter.value !== "") {
          return true;
        }
      }
      return false;
    },
    async refresh(filterDatas: { [key: string]: { operator: string; value: any } }) {
      if (this.valid) {
        const filter = [];
        for (const filterKey in filterDatas) {
          if (this.isFilterActive(filterDatas[filterKey])) {
            filter.push({
              operator: filterDatas[filterKey].operator,
              key: filterKey,
              value: filterDatas[filterKey].value,
            });
          }
        }
        this.$emit("input", filter.concat(this.initialQuery));
      }
    },
  },
});
